/**
 * @internal
 */
export var ProductTypeUrlSuffix = {
    Family: 'family',
    Group: 'group',
    Product: 'product',
};
